export const DECISION_PICKED = 'picked';
export const DECISION_NOT_PICKED = 'not_picked';

/**
 * Parses a shipment ID form value into a positive number, or returns an error message.
 *
 * @param {string} value
 * @returns {{ shipmentId: number } | { error: string }}
 */
export function parseShipmentIdInput(value) {
    const trimmed = value.trim();
    if (!trimmed) {
        return { error: 'Enter a shipment ID' };
    }
    const parsed = Number(trimmed);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        return { error: 'Shipment ID must be a positive number' };
    }
    return { shipmentId: parsed };
}

/**
 * Builds the logPicks request body from shipment lookup data and per-item decisions.
 *
 * @param {Object} params
 * @param {number} params.shipmentId
 * @param {Object} params.shipmentData - GET unpickedItems response data
 * @param {Record<string, 'picked'|'not_picked'>} params.decisions
 * @param {number} [params.pickerId]
 */
export function buildLogPicksPayload({ decisions, pickerId, shipmentData, shipmentId }) {
    const picks = [];
    const outOfStock = [];

    for (const item of shipmentData.unpicked ?? []) {
        const decision = decisions[item.sellableItemId];
        if (decision === DECISION_PICKED) {
            picks.push({
                sellableItemId: item.sellableItemId,
                qtyPicked: item.expectedQuantity,
            });
        } else if (decision === DECISION_NOT_PICKED) {
            outOfStock.push(item.sellableItemId);
        }
    }

    return {
        packLine: shipmentData.packLineNumber,
        facilityID: shipmentData.facilityId,
        shipmentId,
        pickerId: pickerId ?? 0,
        picks,
        outOfStock,
    };
}
